'use client';

import { c as _c } from "react/compiler-runtime";
import { trackEvent } from '@svs/nova-core/analytics';
import { useShareableCouponUrlFromOutcomes } from '@svs/nova-poolbetting/core/frameworks/nextjs/coupon';
import { useDraw } from '@svs/nova-poolbetting/core/nextjs/draw';
import type { Coupon } from '@svs/nova-poolbetting/schema/coupon';
import { ShareButton } from '@svs/nova-poolbetting/ui/ShareButton';
import type { ReactNode } from 'react';
const handleTracking = (label: string, pathname: string): void => {
  trackEvent({
    category: 'Nya tipsen',
    action: label,
    optLabel: pathname
  });
};
type ShareButtonContainerProps = {
  coupon: Coupon;
  pathname: string;
};

/**
 * Component for ShareButtonContainer.
 *
 * @param root0 Component props
 * @param root0.coupon The coupon data
 * @param root0.pathname The current pathname for tracking purposes
 * @returns ShareButtonContainer component
 */
export function ShareButtonContainer(t0) {
  const $ = _c(14);
  const {
    coupon,
    pathname
  } = t0;
  let t1;
  if ($[0] !== coupon.drawNumber || $[1] !== coupon.product) {
    t1 = {
      product: coupon.product,
      drawNumber: coupon.drawNumber
    };
    $[0] = coupon.drawNumber;
    $[1] = coupon.product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const draw = useDraw(t1);
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";
  let t2;
  if ($[3] !== coupon.boards[0]?.outcomes) {
    t2 = coupon.boards[0]?.outcomes ?? [];
    $[3] = coupon.boards[0]?.outcomes;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== coupon.drawNumber || $[6] !== coupon.product || $[7] !== t2) {
    t3 = {
      product: coupon.product,
      drawNumber: coupon.drawNumber,
      outcomes: t2,
      basePath
    };
    $[5] = coupon.drawNumber;
    $[6] = coupon.product;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const url = useShareableCouponUrlFromOutcomes(t3);
  if (draw.isError) {
    return;
  }
  if (draw.data.draw.drawState.client !== "Opened") {
    return;
  }
  let t4;
  if ($[9] !== pathname) {
    t4 = () => {
      handleTracking("Dela", pathname);
    };
    $[9] = pathname;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4 || $[12] !== url) {
    t5 = <ShareButton isDisabled={false} url={url} className="lg:w-fit" text="Dela" onClick={t4} />;
    $[11] = t4;
    $[12] = url;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}